var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container home"},[_c('div',{staticClass:"text1"},[_vm._v("WELCOME")]),_c('div',{staticClass:"text2"},[_vm._v("欢迎进入鑫源全球客户服务管理平台")])])
}]

export { render, staticRenderFns }